module.exports = "/packs/media/images/budget6-39f4fcbd6e477afe872befb9e4efcf8f.jpg";